import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
// 导入i18n
import i18n from './i18n/i18n';
// import VConsole from 'vconsole';
Vue.use(ElementUI);
Vue.config.productionTip = false
// if (process.env.NODE_ENV === 'development') { new VConsole(); }
// new VConsole();
new Vue({
  el: '#app',
  router,
  i18n, // 这里记得也要加上
  store,
  render: h => h(App)
});